module.exports = __webpack_public_path__ + "img/black-vip-point.98eb01b2.png";